
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Accommodations from './components/Accommodations';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-stone-50">
      <Hero />
      <About />
      <Gallery />
      <Accommodations />
      <Testimonials />
      <Booking />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
